(() => {
  const translations = {
  "de": {
    "label": "Fotos (optional)",
    "choose": "Fotos auswählen",
    "hint": "Bis zu 3 Fotos als JPG, PNG oder WebP. Maximal 5 MB pro Foto und 10 MB zusammen. Erst beim Senden werden die Bilder hochgeladen.",
    "remove": "Entfernen",
    "photos": "Fotos",
    "invalid": "Bitte höchstens 3 Fotos als JPG, PNG oder WebP auswählen: maximal 5 MB je Foto und 10 MB zusammen.",
    "sending": "Anfrage und Fotos werden gesendet …",
    "failed": "Der Versand wurde nicht bestätigt. Deine Angaben und Fotos bleiben erhalten. Bitte versuche es später erneut.",
    "pending": "Der Versandstatus ist unklar. Bitte sende nicht nochmals, sondern frage mit dieser Referenz per E-Mail bei uns nach:",
    "limited": "Zu viele Versuche. Bitte versuche es später erneut.",
    "success": "Danke! Deine Anfrage mit Fotos wurde zum Versand übergeben."
  },
  "en": {
    "label": "Photos (optional)",
    "choose": "Choose photos",
    "hint": "Up to 3 JPG, PNG or WebP photos. Maximum 5 MB each and 10 MB in total. Images are uploaded only when you send.",
    "remove": "Remove",
    "photos": "Photos",
    "invalid": "Choose up to 3 JPG, PNG or WebP photos: maximum 5 MB each and 10 MB in total.",
    "sending": "Sending your enquiry and photos …",
    "failed": "Sending was not confirmed. Your details and photos are kept. Please try again later.",
    "pending": "The sending status is unclear. Please do not resend; email us with this reference instead:",
    "limited": "Too many attempts. Please try again later.",
    "success": "Thank you! Your enquiry with photos has been handed over for sending."
  },
  "fr": {
    "label": "Photos (facultatif)",
    "choose": "Choisir des photos",
    "hint": "Jusqu’à 3 photos JPG, PNG ou WebP. Maximum 5 Mo par photo et 10 Mo au total. Les images sont transférées uniquement à l’envoi.",
    "remove": "Retirer",
    "photos": "Photos",
    "invalid": "Choisissez jusqu’à 3 photos JPG, PNG ou WebP : maximum 5 Mo chacune et 10 Mo au total.",
    "sending": "Envoi de votre demande et des photos …",
    "failed": "L’envoi n’a pas été confirmé. Vos informations et photos sont conservées. Réessayez plus tard.",
    "pending": "Le statut de l’envoi est incertain. Ne renvoyez pas la demande ; écrivez-nous avec cette référence :",
    "limited": "Trop de tentatives. Réessayez plus tard.",
    "success": "Merci ! Votre demande avec photos a été transmise pour envoi."
  },
  "it": {
    "label": "Foto (facoltative)",
    "choose": "Scegli foto",
    "hint": "Fino a 3 foto JPG, PNG o WebP. Massimo 5 MB ciascuna e 10 MB totali. Le immagini vengono caricate solo all’invio.",
    "remove": "Rimuovi",
    "photos": "Foto",
    "invalid": "Scegli fino a 3 foto JPG, PNG o WebP: massimo 5 MB ciascuna e 10 MB totali.",
    "sending": "Invio della richiesta e delle foto …",
    "failed": "L’invio non è stato confermato. Dati e foto restano disponibili. Riprova più tardi.",
    "pending": "Lo stato dell’invio non è chiaro. Non inviare di nuovo; scrivici via email con questo riferimento:",
    "limited": "Troppi tentativi. Riprova più tardi.",
    "success": "Grazie! La richiesta con foto è stata inoltrata per l’invio."
  },
  "es": {
    "label": "Fotos (opcional)",
    "choose": "Elegir fotos",
    "hint": "Hasta 3 fotos JPG, PNG o WebP. Máximo 5 MB cada una y 10 MB en total. Se suben solo al enviar.",
    "remove": "Quitar",
    "photos": "Fotos",
    "invalid": "Elige hasta 3 fotos JPG, PNG o WebP: máximo 5 MB cada una y 10 MB en total.",
    "sending": "Enviando tu consulta y fotos …",
    "failed": "El envío no se ha confirmado. Tus datos y fotos se conservan. Inténtalo más tarde.",
    "pending": "El estado del envío no está claro. No lo envíes de nuevo; escríbenos con esta referencia:",
    "limited": "Demasiados intentos. Inténtalo más tarde.",
    "success": "¡Gracias! Tu consulta con fotos se ha entregado para su envío."
  },
  "pl": {
    "label": "Zdjęcia (opcjonalnie)",
    "choose": "Wybierz zdjęcia",
    "hint": "Do 3 zdjęć JPG, PNG lub WebP. Maksymalnie 5 MB każde i 10 MB łącznie. Zdjęcia przesyłamy dopiero po wysłaniu zgłoszenia.",
    "remove": "Usuń",
    "photos": "Zdjęcia",
    "invalid": "Wybierz do 3 zdjęć JPG, PNG lub WebP: maksymalnie 5 MB każde i 10 MB łącznie.",
    "sending": "Wysyłanie zgłoszenia i zdjęć …",
    "failed": "Wysyłka nie została potwierdzona. Dane i zdjęcia pozostają dostępne. Spróbuj później.",
    "pending": "Status wysyłki jest niejasny. Nie wysyłaj ponownie; napisz do nas, podając ten numer:",
    "limited": "Zbyt wiele prób. Spróbuj później.",
    "success": "Dziękujemy! Zgłoszenie ze zdjęciami przekazano do wysyłki."
  },
  "sv": {
    "label": "Bilder (valfritt)",
    "choose": "Välj bilder",
    "hint": "Upp till 3 JPG-, PNG- eller WebP-bilder. Högst 5 MB per bild och 10 MB totalt. Bilder laddas upp först när du skickar.",
    "remove": "Ta bort",
    "photos": "Bilder",
    "invalid": "Välj upp till 3 JPG-, PNG- eller WebP-bilder: högst 5 MB per bild och 10 MB totalt.",
    "sending": "Skickar din fråga och dina bilder …",
    "failed": "Sändningen har inte bekräftats. Dina uppgifter och bilder finns kvar. Försök igen senare.",
    "pending": "Sändningsstatus är oklar. Skicka inte igen; mejla oss med denna referens:",
    "limited": "För många försök. Försök igen senare.",
    "success": "Tack! Din fråga med bilder har lämnats över för sändning."
  },
  "fi": {
    "label": "Kuvat (valinnainen)",
    "choose": "Valitse kuvat",
    "hint": "Enintään 3 JPG-, PNG- tai WebP-kuvaa. Enintään 5 Mt kukin ja 10 Mt yhteensä. Kuvat ladataan vasta lähettäessä.",
    "remove": "Poista",
    "photos": "Kuvat",
    "invalid": "Valitse enintään 3 JPG-, PNG- tai WebP-kuvaa: 5 Mt kukin ja 10 Mt yhteensä.",
    "sending": "Lähetetään kysymystä ja kuvia …",
    "failed": "Lähetystä ei vahvistettu. Tiedot ja kuvat säilyvät. Yritä myöhemmin uudelleen.",
    "pending": "Lähetyksen tila on epäselvä. Älä lähetä uudelleen; lähetä meille sähköpostia tällä viitteellä:",
    "limited": "Liian monta yritystä. Yritä myöhemmin uudelleen.",
    "success": "Kiitos! Kysymyksesi kuvineen on annettu lähetettäväksi."
  },
  "nl": {
    "label": "Foto’s (optioneel)",
    "choose": "Foto’s kiezen",
    "hint": "Tot 3 JPG-, PNG- of WebP-foto’s. Maximaal 5 MB per foto en 10 MB samen. Foto’s worden pas bij het verzenden geüpload.",
    "remove": "Verwijderen",
    "photos": "Foto’s",
    "invalid": "Kies tot 3 JPG-, PNG- of WebP-foto’s: maximaal 5 MB per foto en 10 MB samen.",
    "sending": "Je vraag en foto’s worden verzonden …",
    "failed": "De verzending is niet bevestigd. Je gegevens en foto’s blijven bewaard. Probeer het later opnieuw.",
    "pending": "De verzendstatus is onduidelijk. Verstuur niet opnieuw; mail ons met deze referentie:",
    "limited": "Te veel pogingen. Probeer het later opnieuw.",
    "success": "Bedankt! Je vraag met foto’s is overgedragen voor verzending."
  }
};
  const root = document.querySelector('[data-monolith-advisors]');
  const panel = root?.querySelector('[data-advisor-photos]');
  if (!panel) return;
  const t = translations[root.dataset.locale?.split('-')[0]] || translations.en;
  const endpoint = 'https://monolith-wishlist.epicbeauty-shop.com/berater-upload/index.php';
  const upload = panel.querySelector('[data-advisor-upload]');
  const picker = panel.querySelector('input[type="file"]');
  const choose = panel.querySelector('[data-advisor-photo-select]');
  const list = panel.querySelector('[data-advisor-photo-list]');
  const status = panel.querySelector('[data-advisor-upload-status]');
  const form = root.querySelector('form');
  const send = root.querySelector('[data-advisor-review-send]');
  const edit = root.querySelector('[data-advisor-review-edit]');
  panel.querySelector('[data-advisor-upload-label]').textContent = t.label;
  panel.querySelector('[data-advisor-upload-hint]').textContent = t.hint;
  choose.textContent = t.choose;
  const fallback = [panel.querySelector('[data-advisor-photo-email]'), panel.querySelector('[data-advisor-photo-hint]')];
  let files = [];
  let ready = false;
  let checking = false;
  let busy = false;
  let uncertain = false;
  let requestId = null;
  function say(text, error = false) {
    status.textContent = text;
    status.dataset.error = String(error);
  }
  function render() {
    list.replaceChildren();
    files.forEach((item, index) => {
      const row = document.createElement('li');
      const image = document.createElement('img');
      image.src = item.url;
      image.alt = '';
      const name = document.createElement('span');
      name.textContent = item.file.name;
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = t.remove;
      remove.setAttribute('aria-label', `${t.remove}: ${item.file.name}`);
      remove.disabled = busy || uncertain;
      remove.addEventListener('click', () => {
        URL.revokeObjectURL(files[index].url);
        files.splice(index, 1);
        requestId = null;
        say('');
        render();
        choose.focus();
      });
      row.append(image, name, remove);
      list.append(row);
    });
    choose.disabled = busy || uncertain || files.length >= 3;
    picker.disabled = busy || uncertain || !ready || panel.hidden;
  }
  function clear() {
    files.forEach(item => URL.revokeObjectURL(item.url));
    files = [];
    picker.value = '';
    requestId = null;
    uncertain = false;
    say('');
    render();
  }
  async function check() {
    if (panel.hidden || checking || ready) { render(); return; }
    checking = true;
    try {
      const response = await fetch(endpoint, { mode:'cors', credentials:'omit', cache:'no-store', signal:AbortSignal.timeout(8000) });
      const info = await response.json();
      ready = response.ok && info.service === 'monolith-advisor-mail/1' && info.ready === true;
      upload.hidden = !ready;
      fallback.forEach(element => { element.hidden = ready; });
    } catch (_) {
      ready = false;
    } finally {
      checking = false;
      render();
    }
  }
  choose.addEventListener('click', () => picker.click());
  picker.addEventListener('change', () => {
    const selected = [...picker.files];
    const combined = [...files.map(item => item.file), ...selected];
    picker.value = '';
    if (combined.length > 3 || combined.some(file => !['image/jpeg','image/png','image/webp'].includes(file.type) || file.size < 1 || file.size > 5 * 1024 * 1024) || combined.reduce((sum, file) => sum + file.size, 0) > 10 * 1024 * 1024) {
      say(t.invalid, true);
      return;
    }
    files.push(...selected.map(file => ({ file, url:URL.createObjectURL(file) })));
    requestId = null;
    say('');
    render();
  });
  form.addEventListener('input', () => { if (!busy && !uncertain) requestId = null; });
  root.addEventListener('monolith:case-change', check);
  root.addEventListener('monolith:reset', clear);
  root.addEventListener('monolith:review', () => {
    root.querySelector('[data-advisor-photo-send-error]')?.remove();
    if (panel.hidden || !files.length) return;
    const row = document.createElement('div');
    const label = document.createElement('dt');
    label.textContent = t.photos;
    const names = document.createElement('dd');
    names.textContent = files.map(item => item.file.name).join('\n');
    row.append(label, names);
    root.querySelector('[data-advisor-review-summary]').append(row);
  });
  async function jpeg(file) {
    let image;
    let temporaryUrl;
    if (typeof createImageBitmap === 'function') {
      image = await createImageBitmap(file, { imageOrientation:'from-image' });
    } else {
      temporaryUrl = URL.createObjectURL(file);
      image = new Image();
      image.src = temporaryUrl;
      await image.decode();
    }
    try {
      const width = image.width || image.naturalWidth;
      const height = image.height || image.naturalHeight;
      const ratio = Math.min(1, 1800 / Math.max(width, height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * ratio));
      canvas.height = Math.max(1, Math.round(height * ratio));
      const context = canvas.getContext('2d');
      if (!context) throw new Error('photo_type');
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(image, 0, 0, canvas.width, canvas.height);
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', .85));
      if (!blob || blob.size > 3 * 1024 * 1024) throw new Error('photo_size');
      return blob;
    } finally {
      image?.close?.();
      if (temporaryUrl) URL.revokeObjectURL(temporaryUrl);
    }
  }
  root.addEventListener('monolith:send', event => {
    if (panel.hidden || !files.length) return;
    event.preventDefault();
    if (!busy && !uncertain) void submitPhotos();
  });
  async function submitPhotos() {
    if (!ready || !form.reportValidity()) return;
    busy = true;
    send.disabled = true;
    edit.disabled = true;
    const previousLabel = send.textContent;
    send.textContent = t.sending;
    say(t.sending);
    render();
    requestId ||= crypto.randomUUID();
    let attemptedSend = false;
    let completed = false;
    try {
      const challengeResponse = await fetch(`${endpoint}?action=challenge&id=${encodeURIComponent(requestId)}`, { mode:'cors', credentials:'omit', cache:'no-store', headers:{'X-Monolith-Advisor':'1'}, signal:AbortSignal.timeout(10000) });
      const challenge = await challengeResponse.json();
      if (!challengeResponse.ok || !challenge.ok) throw new Error(challenge.code || 'service_unavailable');
      const start = performance.now();
      const data = new FormData();
      data.set('token', challenge.token);
      data.set('name', root.querySelector('#monolith-advisor-name').value);
      data.set('email', root.querySelector('#monolith-advisor-email').value);
      data.set('message', root.querySelector('#monolith-advisor-message').value);
      data.set('case', panel.dataset.case);
      data.set('website', '');
      const excluded = [t.photos, ...['name','email','message'].map(key => root.querySelector(`label[for="monolith-advisor-${key}"]`)?.textContent)].filter(Boolean);
      const summary = [...root.querySelectorAll('[data-advisor-review-summary] > div')].filter(row => !excluded.includes(row.querySelector('dt')?.textContent)).map(row => ({ label:row.querySelector('dt').textContent, value:row.querySelector('dd').textContent }));
      data.set('fields', JSON.stringify(summary));
      for (let i = 0; i < files.length; i++) data.append('photos[]', await jpeg(files[i].file), `foto-${i + 1}.jpg`);
      const remaining = Math.max(0, 2100 - (performance.now() - start));
      if (remaining) await new Promise(resolve => setTimeout(resolve, remaining));
      attemptedSend = true;
      const response = await fetch(`${endpoint}?action=send`, { method:'POST', mode:'cors', credentials:'omit', headers:{'X-Monolith-Advisor':'1'}, body:data, signal:AbortSignal.timeout(60000) });
      let result;
      try { result = await response.json(); } catch (_) { throw new Error('request_pending'); }
      if (!response.ok || result.ok !== true || !/^MONO-[A-F0-9]{32}$/.test(result.reference || '')) throw new Error(result.code || 'request_pending');
      completed = true;
      clear();
      root.dispatchEvent(new CustomEvent('monolith:photos-sent', { detail:{ title:t.success, reference:result.reference } }));
    } catch (error) {
      const code = error.message;
      const ambiguous = code === 'request_pending' || (attemptedSend && !['rate_limited','photo_type','photo_size','photo_dimensions','photo_count','photo_upload','invalid_fields','token_expired','token_invalid','mail_failed'].includes(code));
      const reference = `MONO-${requestId.replaceAll('-', '').toUpperCase()}`;
      if (ambiguous) {
        uncertain = true;
        say(`${t.pending} ${reference} (info@monolith-shop.eu)`, true);
      } else {
        requestId = null;
        say(code === 'rate_limited' ? t.limited : code.startsWith('photo_') ? t.invalid : t.failed, true);
      }
      const review = root.querySelector('[data-advisor-view="review"]');
      let errorNote = review.querySelector('[data-advisor-photo-send-error]');
      if (!errorNote) {
        errorNote = document.createElement('p');
        errorNote.dataset.advisorPhotoSendError = '';
        errorNote.className = 'mono-advisors__error';
        errorNote.setAttribute('role', 'alert');
        errorNote.tabIndex = -1;
        review.append(errorNote);
      }
      errorNote.textContent = status.textContent;
      errorNote.focus();
    } finally {
      busy = false;
      send.disabled = uncertain;
      edit.disabled = uncertain;
      send.textContent = previousLabel;
      render();
      if (completed) root.querySelector('[data-advisor-photo-send-error]')?.remove();
    }
  }
  window.addEventListener('pageshow', () => { send.disabled = busy || uncertain; edit.disabled = busy || uncertain; });
  window.addEventListener('pagehide', event => { if (!event.persisted) files.forEach(item => URL.revokeObjectURL(item.url)); });
})();

